import { useEffect } from "react";

const SITE_NAME = "The Intuitive Leader";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_gut-trust-preview/artifacts/yo6p8ogh_Copy%20of%20Cropped%20chair%20mau.png";

function upsertMeta(attr, key, content) {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

export function useSeo(title, description, options = {}) {
  const { image = DEFAULT_IMAGE, type = "website", jsonLd = null, keywords = null, noindex = false } = options;

  useEffect(() => {
    const url = window.location.origin + window.location.pathname;
    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");

    upsertLink("canonical", url);

    // Open Graph
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", title || SITE_NAME);
    if (description) upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image);

    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title || SITE_NAME);
    if (description) upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    // Per-page structured data
    const SCRIPT_ID = "page-jsonld";
    let script = document.getElementById(SCRIPT_ID);
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = SCRIPT_ID;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }

    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [title, description, image, type, jsonLd, keywords, noindex]);
}
